import Clickable from "@insite/mobius/Clickable";
import { Icon } from "@insite/mobius/index";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import Card from "@midland-industries/Components/Card";
import Group from "@midland-industries/Components/Group";
import Stack from "@midland-industries/Components/Stack";
import IconArrowNarrowRight from "@midland-industries/Icons/IconArrowNarrowRight";
import { colors } from "@midland-industries/Styles/colors";
import React, { useState } from "react";
import styled from "styled-components";

const INDUSTRIES = {
    INDUSTRIAL: "INDUSTRIAL",
    PLUMBING: "PLUMBING",
    WATERWORKS: "WATERWORKS",
    MARINE: "MARINE",
};

const Wrapper = styled.div`
    @keyframes animation-fade-in {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
    animation: animation-fade-in 0.5s ease-in-out;
    z-index: 1;
`;

const IndustrialImg = styled.div`
    @keyframes animation-fade-in {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
    animation: animation-fade-in 0.5s ease-in-out;
    width: 458px;
    height: 513px;
    aspect-ratio: cos(30deg);
    clip-path: polygon(-50% 50%, 50% 100%, 150% 50%, 50% 0);
    background-image: url("/staticContent/industrial.png");
    background-size: cover;
    position: absolute;
    right: 46px;
    top: -50px;
`;

const PlumbingImg = styled.div`
    @keyframes animation-fade-in {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
    animation: animation-fade-in 0.5s ease-in-out;
    width: 458px;
    height: 513px;
    aspect-ratio: cos(30deg);
    clip-path: polygon(-50% 50%, 50% 100%, 150% 50%, 50% 0);
    background-image: url("/staticContent/plumbing.png");
    background-size: cover;
    position: absolute;
    right: 46px;
    top: -50px;
`;

const WaterworksImg = styled.div`
    @keyframes animation-fade-in {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
    animation: animation-fade-in 0.5s ease-in-out;
    width: 458px;
    height: 513px;
    aspect-ratio: cos(30deg);
    clip-path: polygon(-50% 50%, 50% 100%, 150% 50%, 50% 0);
    background-image: url("/staticContent/waterworks.png");
    background-size: cover;
    position: absolute;
    right: 46px;
    top: -50px;
`;

const MarineImg = styled.div`
    @keyframes animation-fade-in {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
    animation: animation-fade-in 0.5s ease-in-out;
    width: 458px;
    height: 513px;
    aspect-ratio: cos(30deg);
    clip-path: polygon(-50% 50%, 50% 100%, 150% 50%, 50% 0);
    background-image: url("/staticContent/marine.png");
    background-size: cover;
    position: absolute;
    right: 46px;
    top: -50px;
`;

const Industries: React.FC = () => {
    const { INDUSTRIAL, MARINE, PLUMBING, WATERWORKS } = INDUSTRIES;
    const [selected, setSelected] = useState(INDUSTRIAL);

    return (
        <Group
            style={{ width: 1065, margin: "0 auto", padding: "60px 0 175px 0", position: "relative" }}
            align="center"
            gap={90}
        >
            <Stack gap={60}>
                <Typography color={colors.textAccent} size={24} lineHeight="24px" transform="uppercase">
                    industries we serve
                </Typography>
                <Stack gap={24} style={{ paddingLeft: 45 }}>
                    <Clickable onClick={() => setSelected(INDUSTRIAL)}>
                        <Typography
                            color={selected === INDUSTRIAL ? colors.textMain : colors.textAccent}
                            style={{ opacity: selected === INDUSTRIAL ? 1 : 0.3 }}
                            size={40}
                            weight={700}
                            lineHeight="48px"
                        >
                            Industrial
                        </Typography>
                    </Clickable>
                    <Clickable onClick={() => setSelected(PLUMBING)}>
                        <Typography
                            color={selected === PLUMBING ? colors.textMain : colors.textAccent}
                            style={{ opacity: selected === PLUMBING ? 1 : 0.3 }}
                            size={40}
                            weight={700}
                            lineHeight="48px"
                        >
                            Plumbing
                        </Typography>
                    </Clickable>
                    <Clickable onClick={() => setSelected(WATERWORKS)}>
                        <Typography
                            color={selected === WATERWORKS ? colors.textMain : colors.textAccent}
                            style={{ opacity: selected === WATERWORKS ? 1 : 0.3 }}
                            size={40}
                            weight={700}
                            lineHeight="48px"
                        >
                            Waterworks
                        </Typography>
                    </Clickable>
                    <Clickable onClick={() => setSelected(MARINE)}>
                        <Typography
                            color={selected === MARINE ? colors.textMain : colors.textAccent}
                            style={{ opacity: selected === MARINE ? 1 : 0.3 }}
                            size={40}
                            weight={700}
                            lineHeight="48px"
                        >
                            Marine
                        </Typography>
                    </Clickable>
                </Stack>
            </Stack>
            {selected === INDUSTRIAL ? (
                <Wrapper>
                    <Card width={360} borderRadius={10} cardStyles={{ marginTop: 70, zIndex: 1 }}>
                        <Stack gap={12} style={{ padding: 30 }}>
                            <Typography
                                lineHeight="24px"
                                color={colors.textAccent}
                                style={{ letterSpacing: "-0.176px" }}
                            >
                                Midland Industries is your leading supplier and manufacturer of fittings, valves, hose,
                                clamps, and accessories for the Industrial market. Midland's Industrial products are
                                widely used in the Industrial Hose, Fluid Power, Fastener, Heavy Duty Truck and Trailer,
                                Farm and Agricultural, and OEM markets.
                            </Typography>
                            <Group justify="space-between" align="center">
                                <Link href="/Markets/Industrial">Shop all Industrial products</Link>
                                <Icon src={IconArrowNarrowRight} color={colors.textLink} />
                            </Group>
                        </Stack>
                    </Card>
                </Wrapper>
            ) : (
                <></>
            )}
            {selected === PLUMBING ? (
                <Wrapper>
                    <Card width={360} borderRadius={10} cardStyles={{ marginTop: 70, zIndex: 1 }}>
                        <Stack gap={12} style={{ padding: 30 }}>
                            <Typography
                                lineHeight="24px"
                                color={colors.textAccent}
                                style={{ letterSpacing: "-0.176px" }}
                            >
                                Midland Industries is quickly becoming a leader in plumbing and PVF. Our growth has been
                                across all product lines; flare and compression, malleable, lead-free brass, pex and
                                stainless steel fittings, steel, brass and stainless nipples, as well as a full line of
                                ball valves, and ...
                            </Typography>
                            <Group justify="space-between" align="center">
                                <Link href="/Markets/Plumbing">Shop all Plumbing products</Link>
                                <Icon src={IconArrowNarrowRight} color={colors.textLink} />
                            </Group>
                        </Stack>
                    </Card>
                </Wrapper>
            ) : (
                <></>
            )}
            {selected === WATERWORKS ? (
                <Wrapper>
                    <Card width={360} borderRadius={10} cardStyles={{ marginTop: 70, zIndex: 1 }}>
                        <Stack gap={12} style={{ padding: 30 }}>
                            <Typography
                                lineHeight="24px"
                                color={colors.textAccent}
                                style={{ letterSpacing: "-0.176px" }}
                            >
                                Midland Industries is quickly emerging as a full line supplier of products for the
                                waterworks and irrigation industries. Our focus is to source the products commonly used
                                in these markets and inventory them in our 5 regional warehouses. We have introduced
                                many new items in the past two years includ...
                            </Typography>
                            <Group justify="space-between" align="center">
                                <Link href="/Markets/Waterworks">Shop all Waterworks products</Link>
                                <Icon src={IconArrowNarrowRight} color={colors.textLink} />
                            </Group>
                        </Stack>
                    </Card>
                </Wrapper>
            ) : (
                <></>
            )}
            {selected === MARINE ? (
                <Wrapper>
                    <Card width={360} borderRadius={10} cardStyles={{ marginTop: 70, zIndex: 1 }}>
                        <Stack gap={12} style={{ padding: 30 }}>
                            <Typography
                                lineHeight="24px"
                                color={colors.textAccent}
                                style={{ letterSpacing: "-0.176px" }}
                            >
                                Midland Industries is your leading supplier and manufacturer of fittings, valves, hose,
                                clamps, and accessories for the Marine market. Our marine solutions are manufactured to
                                resist damage and corrosion from the harsh marine environment.
                            </Typography>
                            <Group justify="space-between" align="center">
                                <Link href="/Markets/Marine">Shop all Marine products</Link>
                                <Icon src={IconArrowNarrowRight} color={colors.textLink} />
                            </Group>
                        </Stack>
                    </Card>
                </Wrapper>
            ) : (
                <></>
            )}
            {selected === INDUSTRIAL ? <IndustrialImg /> : <></>}
            {selected === PLUMBING ? <PlumbingImg /> : <></>}
            {selected === WATERWORKS ? <WaterworksImg /> : <></>}
            {selected === MARINE ? <MarineImg /> : <></>}
        </Group>
    );
};

export default Industries;
